import React, { useContext, useEffect, useState } from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

function AddP() {
    const navigate = useNavigate();
    const {profile} = useContext(AuthContext);
    const [product, setProduct] = useState({
        auto_update: 0,
        SKU: '',
        EAN: '',
        HS_CODE: '',
        Origin: '',
        Description_EN: '',
        Description_FIN: '',
        Parent_id: '',
        Category_id: '',
        MARKA_ID: '',
        seller_id: '',
        Foto: '',
        pdf: '',
        KG: '',
        stock: '',
        Price: '',
        username: profile.username
    });
    const [categories, setCategories] = useState([]);
    const [markas, setMarkas] = useState([]);
    const [sellers, setSellers] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setProduct((prev) => ({
            ...prev,
            [name]: value,
        }));
        console.log(product);
    };
    const handleSwitchChange = (e) => {
        const { checked } = e.target;
        setProduct((prev) => ({
            ...prev,
            auto_update: checked ? 1 : 0,
        }));
    };
    const handleSave = async () => {
        try {
            const response = await fetch('https://elnaf.fi/apiElnaf/api/addProduct.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(product),
            });
            const result = await response.json();
            console.log(result);
            if (result.status === 'success') {
                alert('Product added successfully!');
                navigate('/products');
            } else {
                alert('Error: ' + result.message);
            }
        } catch (error) {
            console.error('Error adding product:', error);
        }
    };

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const responseC = await fetch('https://elnaf.fi/apiElnaf/api/allCategory.php');
                const dataC = await responseC.json();
                setCategories(dataC);

                const responseM = await fetch('https://elnaf.fi/apiElnaf/api/allMarka.php');
                const dataM = await responseM.json();
                setMarkas(dataM);

                const responseS = await fetch('https://elnaf.fi/apiElnaf/api/allSellers.php');
                const dataS = await responseS.json();
                setSellers(dataS);
            } catch (error) {
                console.error('Error fetching initial data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, []);

    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card custom-card">
                    <div className="p-3 border-bottom border-top border-block-end-dashed tab-content">
                        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-1">
                            <div className="fw-semibold d-block fs-15">Add New Product</div>
                            <div>
                                <FormControlLabel control={<Switch checked={product.auto_update == 1} onChange={handleSwitchChange} />} label="Auto update" />
                            </div>
                        </div>
                        <div className="row gy-3">
                            <div className="col-xl-6">
                                <label htmlFor="SKU" className="form-label">SKU</label>
                                <input onChange={handleInputChange} type="text" className="form-control" name="SKU" placeholder="SKU" value={product.SKU} />
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="EAN" className="form-label">EAN</label>
                                <input onChange={handleInputChange} type="text" className="form-control" name="EAN" placeholder="EAN" value={product.EAN} />
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="HS_CODE" className="form-label">HS-CODE</label>
                                <input onChange={handleInputChange} type="text" className="form-control" name="HS_CODE" placeholder="HS-CODE" value={product.HS_CODE} />
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="Origin" className="form-label">Origin</label>
                                <input onChange={handleInputChange} type="text" className="form-control" name="Origin" placeholder="Origin" value={product.Origin} />
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="Description_EN" className="form-label">Description (EN)</label>
                                <input onChange={handleInputChange} type="text" className="form-control" name="Description_EN" placeholder="Description (EN)" value={product.Description_EN} />
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="Description_FIN" className="form-label">Description (FIN)</label>
                                <input onChange={handleInputChange} type="text" className="form-control" name="Description_FIN" placeholder="Description (FIN)" value={product.Description_FIN} />
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="Parent_id" className="form-label">Category</label>
                                <select onChange={handleInputChange} className="form-control" name="Parent_id" value={product.Parent_id}>
                                    <option value="">Select Category</option>
                                    {categories.filter(cat => cat.parent_id === 0).map(category => (
                                        <option key={category.id} value={category.id}>{category.name_en}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="Category_id" className="form-label">Sub Category</label>
                                <select onChange={handleInputChange} className="form-control" name="Category_id" value={product.Category_id}>
                                    <option value="">Select Sub Category</option>
                                    {categories.filter(cat => cat.parent_id == product.Parent_id).map(category => (
                                        <option key={category.id} value={category.id}>{category.name_en}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="MARKA_ID" className="form-label">Marka</label>
                                <select onChange={handleInputChange} className="form-control" name="MARKA_ID" value={product.MARKA_ID}>
                                    <option value="">Select Marka</option>
                                    {markas.map(marka => (
                                        <option key={marka.id} value={marka.id}>{marka.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="seller_id" className="form-label">Seller</label>
                                <select onChange={handleInputChange} className="form-control" name="seller_id" value={product.seller_id}>
                                    <option value="">Select Seller</option>
                                    {sellers.map(seller => (
                                        <option key={seller.id} value={seller.id}>{seller.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="Foto" className="form-label">Photo URL</label>
                                <input onChange={handleInputChange} type="text" className="form-control" name="Foto" placeholder="Photo URL" value={product.Foto} />
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="pdf" className="form-label">PDF URL</label>
                                <input onChange={handleInputChange} type="text" className="form-control" name="pdf" placeholder="PDF URL" value={product.pdf} />
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="KG" className="form-label">Weight (kg)</label>
                                <input onChange={handleInputChange} type="number" className="form-control" name="KG" placeholder="Weight (kg)" value={product.KG} />
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="stock" className="form-label">Stock</label>
                                <input onChange={handleInputChange} type="number" className="form-control" name="stock" placeholder="Stock" value={product.stock} />
                            </div>
                            <div className="col-xl-6">
                                <label htmlFor="Price" className="form-label">Price (€)</label>
                                <input onChange={handleInputChange} type="number" className="form-control" name="Price" placeholder="Price" value={product.Price} />
                            </div>
                        </div>
                        <div className="card-footer border-top-0">
                            <div className="btn-list float-end">
                                <button className="btn btn-primary" onClick={handleSave}>Add Product</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddP;
